<template>
  <v-container ma-0 pa-0>
    <template v-if="isThereData">
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="$t('barGraphics.lbldaterange')"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker range v-model="date">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">{{
            $t("barGraphics.buttons.cancel")
          }}</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-dialog>

      <apexchart type="bar" :options="options" :series="series"></apexchart>
    </template>
    <div v-else class="optional">
      <v-card class="pa-10" color="secondary" dark>
        Not enough operational information (inspections) yet
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
export default {
  async created() {
    await this.$store.dispatch(
      "inspections/bindInspectionsOfEquipment",
      this.$route.params.id
    );
  },

  data: () => ({
    date: [],
    modal: false,
    colors: ["#008450", "#EFB700", "#b81d13"]
  }),
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("inspections", ["inspections"]),
    ...mapGetters("auth", ["isMetric", "isMetax", "adminAndUp"]),
    options() {
      return {
        chart: {
          height: 400,
          background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF",
          type: "bar"
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light"
        },
        colors: this.colors,
        plotOptions: {
          bar: {
            columnWidth: "35%",
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label"
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0
          }
        },
        xaxis: {
          categories: [
            [
              this.$t("barGraphics.zones.zone"),
              this.$t("barGraphics.zones.smooth")
            ],
            [
              this.$t("barGraphics.zones.zone"),
              this.$t("barGraphics.zones.warning")
            ],
            [
              this.$t("barGraphics.zones.zone"),
              this.$t("barGraphics.zones.alarm")
            ]
          ],
          labels: {
            style: {
              colors: this.colors,
              fontSize: "12px"
            }
          }
        }
      };
    },
    isThereData() {
      let inspections = this.inspections;

      let smooth = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 1)
        .value().length;
      let warning = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 2)
        .value().length;
      let alarm = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 3)
        .value().length;

      if (smooth === 0 && warning === 0 && alarm === 0) return false;
      return true;
    },
    series() {
      let inspections = this.inspections;
      let dis = this;
      if (this.date?.length === 2) {
        inspections = this.inspections.filter(function(item) {
          let time = item.dateCreated.toDate().getTime();
          let end = new Date(dis.date[1]).getTime();
          let start = new Date(dis.date[0]).getTime();
          if (end >= start) {
            return time >= start && time <= end;
          } else {
            return time >= end && time <= start;
          }
        });
      }

      let smooth = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 1)
        .value().length;
      let warning = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 2)
        .value().length;
      let alarm = _.chain(inspections)
        .filter(e => e.resume?.status?.value === 3)
        .value().length;

      return [
        {
          name: this.$t("barGraphics.lblinspections"),
          data: [smooth, warning, alarm]
        }
      ];
    }
  }
};
</script>

<style lang="sass" scoped>
.optional
  display: flex
  align-items: center
  justify-content: center
  .v-card
    width: 100%
</style>
